// src/pages/admin/AdminTypes.js
// Gestion des types d'annonces connectée à l'API - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROUTES from '../../constants/routes';
import { CATEGORIES } from '../../data/categories';
import apiClient from '../../api/client';

const AdminTypes = () => {
  const navigate = useNavigate();
  const [types, setTypes] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('sejours');
  const [newType, setNewType] = useState('');

  const loadTypes = async () => {
    setLoading(true);
    try {
      const result = await apiClient.get('/endpoints/types.php?action=list');
      setTypes(result.types || {});
    } catch (err) {
      setTypes({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTypes();
  }, []);

  const handleAdd = async () => {
    if (!newType.trim()) return;
    try {
      await apiClient.post('/endpoints/types.php?action=create', { category: activeCategory, name: newType });
      setNewType('');
      loadTypes();
    } catch (err) {
      alert("Erreur lors de l'ajout du type");
    }
  };

  const handleDelete = async (rowId) => {
    if (!window.confirm('Supprimer ce type ?')) return;
    try {
      await apiClient.delete(`/endpoints/types.php?action=delete&id=${rowId}`);
      loadTypes();
    } catch (err) {
      alert('Erreur lors de la suppression');
    }
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '900px', margin: '0 auto', backgroundColor: '#0A0E1A' },
    header: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', position: 'sticky', top: 0, backgroundColor: '#0A0E1A', zIndex: 50 },
    backButton: { background: 'none', border: 'none', color: '#FFFFFF', fontSize: '20px', cursor: 'pointer' },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    tabs: { display: 'flex', gap: '8px', overflowX: 'auto', padding: '16px 20px', scrollbarWidth: 'none' },
    tab: { display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 14px', borderRadius: '10px', backgroundColor: '#162033', border: '1px solid rgba(255, 255, 255, 0.1)', color: '#A0AEC0', fontSize: '13px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 },
    tabActive: { backgroundColor: 'rgba(255, 215, 0, 0.15)', border: '1px solid rgba(255, 215, 0, 0.3)', color: '#FFD700' },
    addRow: { display: 'flex', gap: '10px', padding: '0 20px 16px' },
    input: { flex: 1, padding: '12px 14px', backgroundColor: '#111827', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '8px', color: '#FFFFFF', fontSize: '14px', outline: 'none' },
    addBtn: { padding: '12px 20px', backgroundColor: '#FFD700', border: 'none', borderRadius: '8px', color: '#0A0E1A', fontSize: '14px', fontWeight: '700', cursor: 'pointer' },
    list: { display: 'flex', flexDirection: 'column', gap: '8px', padding: '0 20px 40px' },
    card: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', backgroundColor: '#162033', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.1)' },
    typeName: { fontSize: '14px', color: '#FFFFFF', fontWeight: '500' },
    deleteBtn: { padding: '6px 12px', backgroundColor: 'rgba(245, 101, 101, 0.15)', color: '#F56565', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' },
    empty: { textAlign: 'center', padding: '32px', color: '#A0AEC0', fontSize: '14px' },
  };

  const currentTypes = types[activeCategory] || [];

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Types d'annonces | Fynho Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(ROUTES.ADMIN_DASHBOARD)}>←</button>
        <div style={styles.title}>Types d'annonces</div>
      </div>

      <div style={styles.tabs} className="hide-scrollbar">
        <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>
        {CATEGORIES.map((cat) => (
          <div
            key={cat.id}
            style={{ ...styles.tab, ...(activeCategory === cat.id ? styles.tabActive : {}) }}
            onClick={() => setActiveCategory(cat.id)}
          >
            <span>{cat.icon}</span>
            {cat.id === 'immobilier' ? 'Parcelles' : cat.id}
          </div>
        ))}
      </div>

      <div style={styles.addRow}>
        <input
          type="text"
          style={styles.input}
          placeholder="Nouveau type..."
          value={newType}
          onChange={(e) => setNewType(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
        />
        <button style={styles.addBtn} onClick={handleAdd}>+ Ajouter</button>
      </div>

      <div style={styles.list}>
        {loading ? (
          <div style={styles.empty}>Chargement...</div>
        ) : currentTypes.length === 0 ? (
          <div style={styles.empty}>Aucun type pour cette catégorie</div>
        ) : (
          currentTypes.map((type) => (
            <div key={type.rowId} style={styles.card}>
              <span style={styles.typeName}>🏷️ {type.name}</span>
              <button style={styles.deleteBtn} onClick={() => handleDelete(type.rowId)}>Suppr.</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminTypes;